/**
 * Bulk Cargo Request Manger.
 *
 * Collection that contins all bulkRequests.
 *
 */


var VRC = VRC || {};

VRC.BulkCargoRequestManager = (function(){
  var LOCALKEY = 'WELS_bulk_request';
  var _bulkCargoRequests = [];

  var clear = function(){
    _bulkCargoRequests = [];
  };

  var loadOnline = function(portId){
    var deferred = $.Deferred();

    var getBulkRequest = VRC.CommunicationService.getBulkCargoRequests(portId);

    getBulkRequest.done(function(owner, data){
      clear();
      parse(data);
      checkForLoadedCargo();
      deferred.resolve(toJson());
    });

    return deferred.promise();
  };

  var saveToLocal = function(){
    g_localsave_object.SetLocalStorageItem(LOCALKEY, toJson())
  };

  var loadFromLocal = function(){
    clear();
    parse(g_localsave_object.GetLocalStorageItem(LOCALKEY));
    checkForLoadedCargo();
  };

  var getBulkCargoRequests = function(){
    return _bulkCargoRequests;
  };

  var getBulkCargoRequestById = function(containerId){
    containerId = parseInt(containerId);

    return _.find(_bulkCargoRequests, function(cargoRequest) {
      return cargoRequest.getContainerId() === containerId;
    });

  };

  var checkForLoadedCargo = function(){
    var loadedCargoRequest = VRC.BulkTankManager.findLoadedCargoItems();
      _.each(_bulkCargoRequests, function(cargoRequest){

      var cargoQty = loadedCargoRequest[cargoRequest.getContainerId()];

        if(cargoQty !== undefined){

          if(cargoQty - cargoRequest.getValueQty() === 0 || cargoRequest.getValueQty() === undefined){


            cargoRequest.setValueQty(0);
          }
          else{

            cargoRequest.subtractValueQty(cargoQty);
          }
        }


    });
  };

  var parse = function(data){
    $.each(data, function(ii, bulkCargoRequestData){
      _bulkCargoRequests.push(VRC.BulkCargoRequest(bulkCargoRequestData));
    });
  };

  var toJson = function(){
    var json = [];
    $.each(getBulkCargoRequests(), function(ii, bulkCargoRequest){
        json.push(bulkCargoRequest.toJson());
    });

    return json;
  };



  return {
    loadOnline : loadOnline,
    parse : parse,
    toJson : toJson,
    saveToLocal : saveToLocal,
    loadFromLocal : loadFromLocal,
    getBulkCargoRequests : getBulkCargoRequests,
    getBulkCargoRequestById : getBulkCargoRequestById,
    clear : clear,

  }
})();
